import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Drawer from "./views/Frame/Drawer";
import DrawerMobile from "./views/Frame/DrawerMobile";
import Home from "./views/Home";
import Login from "./views/Login";
import Routine from "./views/Routine";
import AccountBook from "./views/AccountBook";
import Budget from "./views/Budget";
import Todo from "./views/Todo";
import Youtube from "./views/Youtube";
import ManageBudget from "./views/ManageBudget";
import { useMediaQuery } from "react-responsive";

function App() {
  const isDesktop = useMediaQuery({ query: "(min-width:1224px)" });

  return (
    <BrowserRouter>
      <div className={isDesktop ? "frame" : "frame flex-col"}>
        {isDesktop ? <Drawer></Drawer> : <DrawerMobile></DrawerMobile>}
        <div className={isDesktop ? "app" : "app app-mobile"}>
          <Routes>
            <Route path="/" element={<Home />}></Route>
            <Route path="/login" element={<Login />}></Route>
            <Route path="/account-book" element={<AccountBook />}></Route>
            <Route path="/budget" element={<Budget />}></Route>
            <Route path="/add-budget" element={<ManageBudget />}></Route>
            <Route path="/routine" element={<Routine />}></Route>
            <Route path="/todo" element={<Todo />}></Route>
            <Route path="/youtube" element={<Youtube />}></Route>
          </Routes>
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
